import React, { useEffect } from "react";
import { PostMetadata, formatDate } from "../utils/posts";

interface BlogListProps {
  posts: PostMetadata[];
  onSelectPost: (slug: string) => void;
}

export default function BlogList({ posts, onSelectPost }: BlogListProps) {
  useEffect(() => {
    document.title = "Blog — Tadej Gungl";
  }, []);

  if (posts.length === 0) {
    return (
      <div className="min-h-screen w-full flex flex-col items-center justify-center bg-Base text-Text pt-16 px-6">
        <div className="max-w-md w-full text-center">
          <h2 className="font-display font-medium text-4xl mb-4">Blog</h2>
          <div className="w-full border-t hairline mb-6"></div>
          <p className="text-Subtext0 font-sans">
            No posts yet — check back later.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full bg-Base text-Text pt-24 pb-16 px-6 md:px-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-16">
          <p className="label-caps mb-3">Writing</p>
          <h1 className="font-display font-medium text-5xl md:text-6xl text-Text mb-4">
            Blog
          </h1>
          <p className="text-Subtext0 font-sans">
            Thoughts, notes, and system updates.
          </p>
        </div>

        {/* Posts List */}
        <div>
          {posts.map((post) => (
            <article
              key={post.slug}
              onClick={() => onSelectPost(post.slug)}
              className="cursor-pointer group border-t hairline py-10"
            >
              <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-3">
                <time className="label-caps">{formatDate(post.date)}</time>
                {post.tags.length > 0 && (
                  <span className="label-caps">{post.tags.join(" · ")}</span>
                )}
              </div>

              <h2 className="font-display font-medium text-2xl md:text-3xl text-Text mb-3 group-hover:text-Sapphire transition-colors">
                {post.title}
                <span className="inline-block ml-3 text-Sapphire opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 text-xl">
                  →
                </span>
              </h2>

              <p className="text-Subtext0 font-sans text-base leading-relaxed max-w-2xl">
                {post.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
